import { reduceBusinessObjectiveResponse } from 'pricing-pages-lib/reducers/BusinessObjectives';
import { FetchBusinessObjectivesRequestTypes } from '../actions/BusinessObjectiveActions';
const initialState = {};

const Features = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchBusinessObjectivesRequestTypes.RECEIVE:
      {
        const data = payload && payload.data;
        const highlightedProducts = payload && payload.props && payload.props.highlightedProducts;

        if (data && highlightedProducts) {
          return reduceBusinessObjectiveResponse({
            data,
            state: state
          });
        }

        return state;
      }

    default:
      return state;
  }
};

export default Features;